import { EvaluationStatus } from '../../../commonTypes/evaluation/calculate.types';
import { ActionFooter } from '../../Common';

interface StartEvaluationProcessProps {
    onStart: () => void;
    onCancel: () => void;
    isAnonymous?: boolean;
    evaluatorRole?: string;
    evaluateeName?: string;
    status?: EvaluationStatus.REQUESTED | EvaluationStatus.UPDATE_APPROVED;
}

const StartEvaluationProcess = ({ onStart, onCancel, isAnonymous, evaluatorRole, evaluateeName, status }: StartEvaluationProcessProps) => {
    return (
        <div className="start-evaluation-process-wrapper">
            <div className="start-evaluation-process">
                <div className="start-evaluation-process__icon-container">
                    <img src="/svg/evaluation-start.svg" alt="Start Evaluation" className="start-evaluation-process__icon" />
                </div>

                <div className="start-evaluation-process__content">
                    <h2 className="start-evaluation-process__title">
                        {' '}
                        {status === EvaluationStatus.UPDATE_APPROVED ? 'Edit Your Evaluation' : 'Ready to Start Your Evaluation'}
                    </h2>
                    {evaluateeName && evaluatorRole && (
                        <p className="start-evaluation-process__description">
                            {status === EvaluationStatus.UPDATE_APPROVED ? (
                                <>
                                    You are editing your previous evaluation answers for{' '}
                                    <span className="start-evaluation-process__highlight">{evaluateeName}</span> in the role of{' '}
                                    <span className="start-evaluation-process__highlight">{evaluatorRole}</span>. Make any necessary changes before
                                    submitting.
                                </>
                            ) : (
                                <>
                                    You are starting the evaluation process for{' '}
                                    <span className="start-evaluation-process__highlight">{evaluateeName}</span>, who will be assessed in the role of{' '}
                                    <span className="start-evaluation-process__highlight">{evaluatorRole}</span>. You'll be able to review their
                                    performance, provide feedback, and add notes before submitting the final evaluation.
                                </>
                            )}{' '}
                        </p>
                    )}

                    {isAnonymous !== undefined && (
                        <p className="start-evaluation-process__info">
                            {isAnonymous ? 'This evaluation is anonymous' : 'This evaluation is not anonymous'}
                        </p>
                    )}
                </div>
            </div>
            <ActionFooter
                buttons={[
                    {
                        text: 'Cancel',
                        variant: 'text',
                        color: 'blue',
                        onClick: () => onCancel(),
                    },
                    {
                        text: status === EvaluationStatus.UPDATE_APPROVED ? 'Edit Evaluation' : 'Start Evaluation',
                        variant: 'contained',
                        onClick: () => onStart(),
                    },
                ]}
                className="start-evaluation-process__footer"
            />
        </div>
    );
};

export default StartEvaluationProcess;
